import axios from "axios";
import env from "../config";
// import { setNotification, useNotifcation } from 'context/notification'
import { ReqMethods, ResponseStatus } from "../enums";
// import { useAuth, useLogout } from './auth'

const BASE_URL = `${env.API_URL}`;

function useServiceHandler() {
  // const [, dispatch] = useNotifcation()
  // const Logout = useLogout()

  return (fn) =>
    async (
      method,
      path,
      { query, payload, token, apiKey, toaster, message, error } = {}
    ) => {
      try {
        const res = await fn(method, path, { query, payload, token, apiKey });
        // console.log("API - RESPONSE", res, toaster, message, error);
        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: message || res.data.message,
        //     severity: 'success',
        //     title: 'Success',
        //   })

        return { response: res.data };
      } catch (err) {
        // console.log("API- ERROR", err.response?.data || err);

        // expire error : jwt expired
        if (
          err.response &&
          err.response.status === ResponseStatus.UNAUTHORIZED
        ) {
          // setNotification(dispatch, {
          //   open: true,
          //   message: error || 'session expired',
          //   title: 'Error',
          //   severity: 'error',
          // })
          // setTimeout(Logout, 4000)
          return { error: err.response?.data || err };
        }

        const customError = err.response?.data?.error
          ? `${err.response?.data?.message} \n${err.response?.data?.error}`
          : err.response?.data?.message;

        // toaster &&
        //   setNotification(dispatch, {
        //     open: true,
        //     message: error || customError || err.message,
        //     severity: 'error',
        //     title: 'Error',
        //   })
        return { error: err.response ? err.response.data : err };
      }
    };
}

function useCallService() {
  // const authToken = useAuth()
  const serviceHandler = useServiceHandler();

  const CallService = (
    method,
    path,
    { query, payload, token = true, apiKey = null }
  ) => {
    const pathname = query ? `${path}?${query}` : path;
    const config = {};

    // if (token) config.headers = { 'x-auth-token': `Bearer ${authToken || token}` }
    // if (apiKey) config.headers = { apiKey }

    const details = {};

    if (payload) details.payload = payload;
    details.config = config;

    return axios[method](pathname, ...Object.values(details));
  };

  return serviceHandler(CallService);
}

function useAppServices() {
  const { GET, POST, PUT, DELETE } = ReqMethods;
  const CallService = useCallService();

  /**
    Option for service is the object that could has the following properties
    query, payload, token, apiKey
  */

  const APIs = {
    agency: {
      get: (options) => CallService(GET, `${BASE_URL}/agency`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/agency/filter`, options),
      update: (options) => CallService(PUT, `${BASE_URL}/agency`, options),
      getProducts: (options) =>
        CallService(PUT, `${BASE_URL}/agency/getproducts`, options),
    },
    knowledgebase_category: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_category`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_category`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_category/filter`, options),
      get_location_categories: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_category/get_location_categories`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_category`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_category`, options),
    },
    knowledgebase_sub_category: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_sub_category`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_sub_category`, options),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_sub_category/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_sub_category`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_sub_category`, options),
    },
    knowledgebase_article: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_article`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_article`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_article/filter`, options),
      get_location_articles: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_article/get_location_articles`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_article`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_article`, options),
    },
    knowledgebase_customization: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_customization`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_customization`, options),
      create_custom_menu_link: (options) =>
        CallService(
          POST,
          `${BASE_URL}/knowledgebase_customization/create_custom_menu_link`,
          options
        ),
      filter: (options) =>
        CallService(
          GET,
          `${BASE_URL}/knowledgebase_customization/filter`,
          options
        ),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_customization`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_customization`, options),
    },
    knowledgebase_language: {
      get: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_language`, options),
      create: (options) =>
        CallService(POST, `${BASE_URL}/knowledgebase_language`, options),
      filter: (options) =>
        CallService(GET, `${BASE_URL}/knowledgebase_language/filter`, options),
      update: (options) =>
        CallService(PUT, `${BASE_URL}/knowledgebase_language`, options),
      delete: (options) =>
        CallService(DELETE, `${BASE_URL}/knowledgebase_language`, options),
    },
    utils: {
      upload_image: (options) =>
        CallService(POST, `${BASE_URL}/utils/upload/image`, options),
    },
    services: {
      ghl: {
        call_service: (options) =>
          CallService(POST, `${BASE_URL}/services/ghl/`, options),
      },
    },
  };

  return APIs;
}
const useUploadImage = () => {
  const AppService = useAppServices();
  return ({ toaster, file, desiredPath }) => {
    const form = new FormData();
    form.append("image", file, file.name);
    return AppService.utils.upload_image({
      toaster,
      payload: form,
      query: `desiredPath=${desiredPath}`,
    });
  };
};
export { useAppServices, useCallService, useUploadImage };
